// src/services/studentService.js
import axios from '../utils/axios';

// Öğrencinin kayıtlı olduğu kursları getir
export const fetchStudentCourses = async () => {
  try {
    const response = await axios.get('/student/courses');
    return response.data;
  } catch (error) {
    console.error('Kurslar yüklenirken hata:', error);
    throw error;
  }
};

// Tek bir kursu getir
export const getCourseById = async (courseId) => {
  try {
    const response = await axios.get(`/courses/${courseId}`);
    return response.data;
  } catch (error) {
    console.error('Kurs yüklenirken hata:', error);
    throw error;
  }
};

// Kurs modüllerini getir
export const getCourseModules = async (courseId) => {
  try {
    const response = await axios.get(`/modules/course/${courseId}`);
    return response.data;
  } catch (error) {
    console.error('Modüller yüklenirken hata:', error);
    throw error;
  }
};

// Tek bir dersi getir
export const getLessonById = async (lessonId) => {
  try {
    const response = await axios.get(`/lessons/${lessonId}`);
    return response.data;
  } catch (error) {
    console.error('Ders yüklenirken hata:', error);
    throw error;
  }
};

// Öğrencinin yaklaşan derslerini getir
export const fetchUpcomingLessons = async () => {
  try {
    const response = await axios.get('/student/lessons/upcoming');
    return response.data;
  } catch (error) {
    console.error('Dersler yüklenirken hata:', error);
    throw error;
  }
};

// Öğrencinin tüm derslerini getir (geçmiş + gelecek)
export const fetchAllLessons = async () => {
  try {
    const response = await axios.get('/lessons/my-lessons');
    return response.data;
  } catch (error) {
    console.error('Dersler yüklenirken hata:', error);
    throw error;
  }
};

// Öğrencinin sertifikalarını getir
export const fetchCertificates = async () => {
  try {
    const response = await axios.get('/certificates/my-certificates');
    return response.data;
  } catch (error) {
    console.error('Sertifikalar yüklenirken hata:', error);
    return [];
  }
};

// Sertifika indir
export const downloadCertificate = async (courseId) => {
  try {
    const response = await axios.get(`/certificates/${courseId}`, {
      responseType: 'blob'
    });
    
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `sertifika-${courseId}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    
    return true;
  } catch (error) {
    console.error('Sertifika indirilirken hata:', error);
    throw error;
  }
};

// Öğrencinin ilerlemesini getir (YENİ)
export const getCourseProgress = async (courseId) => {
  try {
    const response = await axios.get(`/progress/course/${courseId}`);
    return response.data;
  } catch (error) {
    console.error('İlerleme yüklenirken hata:', error);
    throw error;
  }
};

// Ders tamamla (YENİ)
export const completeLesson = async (courseId, lessonId) => {
  try {
    const response = await axios.post(`/progress/course/${courseId}/lesson/${lessonId}/complete`);
    return response.data;
  } catch (error) {
    console.error('Ders tamamlanırken hata:', error);
    throw error;
  }
};

// Quiz başlat (YENİ)
export const startQuiz = async (quizId) => {
  try {
    const response = await axios.post(`/quizzes/${quizId}/start`);
    return response.data;
  } catch (error) {
    console.error('Quiz başlatılırken hata:', error);
    throw error;
  }
};

// Quiz tamamla (YENİ)
export const completeQuiz = async (attemptId, answers, timeSpent) => {
  try {
    const response = await axios.post(`/quizzes/attempt/${attemptId}/complete`, { answers, timeSpent });
    return response.data;
  } catch (error) {
    console.error('Quiz tamamlanırken hata:', error);
    throw error;
  }
};

// Ödev teslim et (YENİ)
export const submitAssignment = async (assignmentId, formData) => {
  try {
    const response = await axios.post(`/assignments/${assignmentId}/submit`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  } catch (error) {
    console.error('Ödev teslim edilirken hata:', error);
    throw error;
  }
};

// Ödev teslimini getir (YENİ)
export const getMySubmission = async (assignmentId) => {
  try {
    const response = await axios.get(`/assignments/${assignmentId}/my-submission`);
    return response.data;
  } catch (error) {
    console.error('Teslim yüklenirken hata:', error);
    throw error;
  }
};